import { render, staticRenderFns } from "./ttdModal.vue?vue&type=template&id=45f7faf4"
import script from "./ttdModal.vue?vue&type=script&lang=js"
export * from "./ttdModal.vue?vue&type=script&lang=js"
import style0 from "./ttdModal.vue?vue&type=style&index=0&id=45f7faf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports